import { SopSicknessLeaveQueryParams } from "Components/Features/CheckPrice/checkPriceTypes";
import { SopSicknessLeaveProductIntroFormValues } from "./sopSicknessLeaveProductIntroInterfaces";

export const getInitialFormState = (
  params: SopSicknessLeaveQueryParams,
): Partial<SopSicknessLeaveProductIntroFormValues> => {
  return {
    revenue: params.revenue ?? undefined,
    dailyPayoutAmount: params.dailyPayoutAmount ?? undefined,
    pep: undefined,
  };
};
